export default function Loading() {

  // useEffect(() => {
  //   document.body.style.overflow = 'hidden';
  // }, [ ]);

  // eslint-disable-next-line react/react-in-jsx-scope
  return <div>loading...</div>
}
